<template>
  <AppContainer class="cover-page-section">
    <AppCard>
      <TextInput
        v-model.trim="planStore.name"
        required
        label="Name"
      />

      <ImageFileInput
        class="[&_img]:!max-w-64 max-w-lg"
        label="District/Metro Logo"
        :deletable="true"
        :preview="planStore.logo"
        @change="planStore.logo = $event.target.files[0] || null"
        @delete="deleteLogo"
      />
    </AppCard>
  </AppContainer>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { useRoute } from 'vue-router';

import { AppContainer } from '@/components/app/index.js';
import { AppCard } from '@/components/cards/index.js';
import { ImageFileInput, TextInput } from '@/components/form-inputs/index.js';

import { useHttp, useToasts } from '@/composables/index.js';
import { usePlanStore } from '@/store/index.js';

const planStore = usePlanStore();
const route = useRoute();
const toasts = useToasts();

const deleteLogo = async () => {
  const response = await useHttp().delete(`/districts/${route.params.district}/plans/${route.params.plan}/logo`);

  if (response.statusCode === HttpStatusCode.Ok) {
    planStore.logo = null;
  } else {
    toasts.error('Unable to delete logo for plan');
  }
};

</script>
